// import { CmCtiService } from './cm-cti.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from "@angular/forms/src/forms";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { Evento } from '../../model/evento';


@Component({
  selector: 'app-cm-cti',
  templateUrl: './cm-cti.component.html',
  styleUrls: ['./cm-cti.component.css']
})

export class CmCTIComponent implements OnInit {

  private novoEvento: Evento;
  evento: Evento;

    
  constructor() { 
    this.evento = new Evento();
    this.evento.description = "";
  }

  ngOnInit() {
  }




}



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/cm-cti/cm-cti.component.ts